<template>
  <div>
    <div
      class="py-5 flex flex-col md:flex-row justify-between items-center"
    >
      <form @submit.prevent="submitSearch()" class="w-full md:w-auto mb-4 md:mb-0">
        <vs-input
          icon-no-border
          placeholder="Search"
          v-model="searchQuery"
          class="w-full md:w-auto input-square-full"
          icon="icon-search"
          icon-pack="feather"
        />
      </form>
      <vs-button
        @click="$router.push('/org_management/users_add')"
        class="md:w-auto"
        color="#009FB2"
        >Add User</vs-button
      >
    </div>

    <vs-table stripe :data="lists">
      <template slot="thead">
        <vs-th class="text-center">No</vs-th>
        <vs-th @click="toggleSort('firstname')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>First Name</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('firstname')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('firstname', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('firstname', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('lastname')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Last Name</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('lastname')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('lastname', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('lastname', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('email')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Email</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('email')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('email', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('email', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('company_name')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Company</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('company_name')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('company_name', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('company_name', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('role_name')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Role</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('role_name')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('role_name', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('role_name', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th class="text-left">Sites</vs-th>
        <vs-th @click="toggleSort('status')" class="text-center cursor-pointer">
          <div class="flex items-center justify-center">
            <span>Status</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('status')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('status', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('status', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th class="text-center">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr class="pln-color" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="indextr">
            {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.firstname">
            {{ tr.user.firstname }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.lastname">
            {{ tr.user.lastname }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.email">
            {{ tr.user.email }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.company">
            {{ tr.user.company.name }}
          </vs-td>

          <vs-td
            class="text-left"
            :data="tr.user.role ? tr.user.role.name : ''"
          >
            {{ tr.user.role ? tr.user.role.name : "" }}
          </vs-td>

          <vs-td class="text-left">
            <div class="sites-chips-container">
              <vs-chip
                :key="idx"
                v-for="(uSite, idx) in tr.siteAccess"
                :color="randColor()"
                >{{ uSite.siteName }}</vs-chip
              >
            </div>
          </vs-td>

          <vs-td class="text-center" :data="tr.user.statusId">
            {{ tr.user.statusId ? "Enabled" : "Disabled" }}
          </vs-td>

          <vs-td class="text-right">
            <div class="flex justify-center gap-mini">
              <!-- <vs-tooltip text="Embed Link Access">
                <a href="" @click.prevent="embedAccess(tr)">
                  <feather-icon icon="LinkIcon" size="20" />
                </a>
              </vs-tooltip> -->
              <vs-tooltip text="Edit">
                <a href="" @click.prevent="updateUser(tr)">
                  <feather-icon icon="EditIcon" size="20" />
                </a>
              </vs-tooltip>
              <vs-tooltip text="Delete">
                <a href="" @click.prevent="confirmDelete(tr.user.id)">
                  <feather-icon icon="TrashIcon" size="20" />
                </a>
              </vs-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="flex justify-between mt-4">
      <div class="flex" style="align-items: center">
        <span class="mr-2">show data</span>
        <vs-select
          class="items-per-page"
          v-model="itemsPerPage"
          @input="updateItemsPerPage"
        >
          <vs-select-item
            v-for="(option, index) in pageOptions"
            :key="index"
            :value="option.value"
            :text="option.text"
          />
        </vs-select>
      </div>
      <CustomPagination
        :current-page.sync="currentPage"
        :total-pages="totalPages"
        :total-data="totalData"
        @update:currentPage="getUserLists"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CustomPagination from "@/components/CustomPagination.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretUp, faCaretDown);

export default {
  components: {
    CustomPagination,
    "font-awesome-icon": FontAwesomeIcon,
  },
  data() {
    return {
      selectedId: "",
      searchQuery: "",
      lists: [],
      itemsPerPage: 10,
      currentPage: 1,
      totalData: 0,
      totalPages: 0,
      sortField: "",
      sortOrder: "asc",
      pageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
    };
  },
  mounted() {
    this.getUserLists();
  },
  methods: {
    randColor() {
      const colors = [
        "primary",
        "success",
        "danger",
        "warning",
        "dark",
        "#24c1a0",
      ];
      const color = Math.floor(Math.random() * colors.length);
      return colors[color];
    },
    submitSearch() {
      this.getUserLists();
    },
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getUserLists();
    },
    getUserLists() {
      this.$vs.loading();
      const params = {
        search: this.searchQuery,
        page: this.currentPage,
        limit: this.itemsPerPage,
      };

      if (this.sortField) {
        const sortField =
          this.sortField === "status" ? "statusId" : this.sortField;
        params.sort = `${sortField} ${this.sortOrder}`;
      }

      console.log("📦 [getUserLists] API Params:", params);

      api
        .users(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getUserLists] Response:", data);
          if (data.status) {
            this.lists = data.data;
            this.totalData = data.totalData;
            this.totalPages = data.maxPage;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getUserLists] Error:", e);
          this.$vs.loading.close();
        });
    },
    toggleSort(field) {
      console.log("🔽 [toggleSort] Clicked field:", field);

      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }

      console.log("🔄 [toggleSort] New sortField:", this.sortField);
      console.log("🔄 [toggleSort] New sortOrder:", this.sortOrder);

      this.getUserLists();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    updateUser(data) {
      this.$store.dispatch("updateCurrentUser", data);
      this.$router.push(`/org_management/update_user/${data.user.id}`);
      console.log(`Datanya ada disini : ${data.user.email}`);
    },
    embedAccess(data) {
      this.$store.dispatch("embedAccess", data);
      this.$router.push(`/org_management/embed_access/${data.user.id}`);
    },
    confirmDelete(id) {
      this.selectedId = id;
      this.$vs.dialog({
        color: "danger",
        title: `Confirm Delete`,
        text: "Are you sure will delete this data?.",
        accept: this.doDelete,
      });
    },
    doDelete() {
      this.$vs.loading();
      api
        .deleteUser({ id: this.selectedId })
        .then((result) => result.data)
        .then((data) => {
          console.log(data);
          this.selectedId = "";

          this.$vs.notify({
            title: "Success",
            text: "Delete data success",
            color: "success",
            position: "top-right",
          });

          this.$vs.loading.close();
        })
        .finally(() => {
          this.getUserLists();
        })
        .catch((e) => {
          console.log(e);
          this.selectedId = "";

          this.$vs.notify({
            title: "Failed",
            text: "Delete data failed",
            color: "danger",
            position: "top-right",
          });

          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 0 5px;
}
.text-center::v-deep .vs-table-text {
  justify-content: center;
}
.text-right::v-deep .vs-table-text {
  justify-content: flex-end;
}
.cursor-pointer {
  cursor: pointer;
}
.sort-icon-group {
  line-height: 0.7;
}
.sort-icon {
  color: white;
  font-size: 12px;
  transition: opacity 0.2s ease;
}
.sort-icon.active {
  opacity: 1;
  color: #009fb2;
}
.items-per-page {
  width: 80px;
}
::v-deep .items-per-page .vs-select {
  width: 100%;
}
.sites-chips-container {
  max-height: 120px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px 0;
}
</style>
